<template>
    <div class="relation">
        <div class="relation-image1">
            <h4>{{schoolName}}真诚邀请您的加入</h4>
            <img src="@/assets/vipCoach/v2/bg_fxyq.png">
        </div>
        <div class="wrap">
            <div class="join-image">
                <img src="@/assets/vipCoach/v2/icon_jrwm.png">
            </div>
            <div class="form">
                <div class="form-item">
                    <img class="form-item__icon" src="@/assets/vipCoach/v2/icon_sj.png" />
                    <input v-model="formCode.phone" class="form-item__input" placeholder="请输入手机号码" type="number" pattern="[0-9]*" @input="() => {formCode.phone.length >11 && (formCode.phone = formCode.phone.slice(0,11))}">
                </div>
                <div class="form-item">
                    <img class="form-item__icon" src="@/assets/vipCoach/v2/icon_txyzm.png" />
                    <input v-model="formCode.imgCode" class="form-item__input" placeholder="请输入图形验证码" type="number" pattern="[0-9]*" @input="() => {formCode.imgCode.length >4 && (formCode.imgCode = formCode.imgCode.slice(0,4))}">
                    <img class="form-item__code" :src="imageCode" />
                    <img class="form-item__reset" src="@/assets/vipCoach/v2/icon_sx01.png" @click="getPhotoCode" />
                </div>
                <div class="form-item">
                    <img class="form-item__icon" src="@/assets/vipCoach/v2/icon_yzm.png" />
                    <input v-model="formData.shortMessageCode" class="form-item__input" placeholder="请输入验证码" type="number" pattern="[0-9]*" @input="() => {formData.shortMessageCode.length >6 && (formData.shortMessageCode = formData.shortMessageCode.slice(0,6))}">
                    <div class="form-item__btn" :class="{ disabled: !!codeTime }" @click="handleGetCode">{{codeTime === 0 ?'获取验证码':`已获取${codeTime}s`}}</div>
                </div>
                <p class="agreement">登录即表示你已阅读并同意<a @click="handleShowAgreement('1')">《用户协议》</a>和<a @click="handleShowAgreement('2')">《隐私政策》</a></p>
            </div>
            <div class="custom-btn" @click="ImmediatelyJoin">立即加入</div>
        </div>
        <van-action-sheet v-model="agreementStatus" :title="agreementType === '1' ? '用户协议': '隐私政策'">
            <div class="agreement-content">
                <agreement :key="agreementStatus && Date.now()" :type="agreementType" />
            </div>
        </van-action-sheet>
        <ctl-dialog :value="dialogValue"></ctl-dialog>
    </div>
</template>
<script>
import { Toast, Button, ActionSheet } from 'vant'
import agreement from '../../components/agreement.vue'
let timer = null
export default {
    name: 'vipCoachRelation',
    components: {
        [Button.name]: Button,
        [ActionSheet.name]: ActionSheet,
        agreement
    },
    data () {
        return {
            schoolName: '',
            imageCode: '',
            formCode: {
                imgCode: '',
                businessType: 'login',
                phone: '',
                uuid: ''
            },
            // 登录表单
            formData: {
                bindSchoolId: '',
                phone: '',
                shortMessageCode: ''
            },
            // 获取验证码倒计时态
            codeTime: 0,
            agreementStatus: false,
            agreementType: '',
            // 弹窗参数
            dialogValue: {
                visible: false
            }
        }
    },
    methods: {
        // 获取图形验证码
        getPhotoCode () {
            this.$api.getCoachPhotoCode({
                width: 100,
                height: 50
            }).then(res => {
                if (res.status) {
                    const { uuid, image } = res.result
                    this.formCode.uuid = uuid
                    this.imageCode = image
                }
            })
        },
        // 获取验证码
        handleGetCode () {
            if (this.codeTime !== 0) {
                return
            }
            if (!/^1\d{10}$/.test(this.formCode.phone)) { // 校验手机号是否合法
                Toast.fail('请输入有效的手机号码')
            } else if (!this.formCode.imgCode) { // 校验验证码是否合法
                Toast.fail('图形验证码不能为空')
            } else {
                Toast.loading({ duration: 0, forbidClick: true })
                this.$api.sendShortMessage(this.formCode).then(res => {
                    Toast.clear()
                    if (res.status) {
                        Toast.success('验证码已发送')
                        // 开启定时器 控制是否点击验证码
                        this.codeTime = 60
                        timer = setInterval(() => {
                            --this.codeTime
                            if (this.codeTime === 0) {
                                clearInterval(timer)
                            }
                        }, 1000)
                    } else {
                        this.getPhotoCode()
                        Toast.fail(res.message)
                    }
                }).catch(() => {
                    Toast.clear()
                })
            }
        },
        // 立即加入
        ImmediatelyJoin () {
            if (!/^1\d{10}$/.test(this.formCode.phone)) { // 校验手机号是否合法
                Toast.fail('请输入有效的手机号码')
            } else if (!this.formData.shortMessageCode) { // 校验验证码是否合法
                Toast.fail('短信验证码不能为空')
            } else {
                let obj = {
                    phone: this.formCode.phone,
                    bindSchoolId: this.formData.bindSchoolId
                }
                this.$api.checkCoachSchoolCanCover(obj).then(res => {
                    if (res.code === '100012') { // 可覆盖
                        this.dialogValue = {
                            visible: true,
                            leftBtnName: '暂不加入',
                            rightBtnName: '继续加入',
                            leftBtnMethod: () => {
                                this.formCode.imgCode = ''
                                this.formCode.uuid = ''
                                this.formData.shortMessageCode = ''
                                clearInterval(timer)
                                this.codeTime = 0
                                this.dialogValue.visible = false
                                this.getPhotoCode()
                            },
                            rightBtnMethod: () => {
                                this.handleSubmit()
                            },
                            title: '温馨提示',
                            content: `<p style="text-align : left;">${res.message}</p>`
                        }
                    } else if (res.code === '100011') { // 无法通过此方式加入
                        this.dialogValue = {
                            visible: true,
                            rightBtnName: '我知道了',
                            rightBtnMethod: () => {
                                this.dialogValue.visible = false
                                this.formCode.phone = ''
                                this.formCode.imgCode = ''
                                this.formCode.uuid = ''
                                this.formData.phone = ''
                                this.formData.shortMessageCode = ''
                                clearInterval(timer)
                                this.codeTime = 0
                                this.getPhotoCode()
                            },
                            title: '温馨提示',
                            content: `<p style="text-align : left;">${res.message}</p>`
                        }
                    } else if (res.code === '200') { // 直接通过
                        this.handleSubmit()
                    }
                })
            }
        },
        // 加入
        handleSubmit () {
            Toast.loading({ duration: 0, forbidClick: true })
            this.formData.phone = this.formCode.phone
            this.$api.getCoachRelationJoin(this.formData).then(res => {
                Toast.clear()
                if (res.status) {
                    Toast.success('恭喜您，加入成功')
                    this.$router.push({
                        name: 'vipCoachRelationSuccess',
                        query: {
                            schoolName: this.$route.query.schoolName,
                            mobile: this.formCode.phone
                        }
                    })
                } else {
                    Toast.fail(res.message)
                }
            }).catch(() => {
                Toast.clear()
            })
        },
        // 展示协议
        handleShowAgreement (type) {
            this.agreementType = type
            this.agreementStatus = true
        }
    },
    mounted () {
        const { schoolName, schoolId } = this.$route.query
        this.formData.bindSchoolId = schoolId
        this.schoolName = schoolName
        this.getPhotoCode()
    },
    destroyed () {
        clearInterval(timer)
    }
}
</script>
<style lang="scss" scoped>
*{
    box-sizing: border-box;
}
img{
    max-width: 100%;
    vertical-align: middle;
}
.relation{
    padding-bottom: 40px;
    min-height: 100vh;
    background: #F56226;
}
.relation-image1{
    position: relative;
    h4{
        position: absolute;
        top: 15px;
        left: 38px;
        color:#fff;
        font-size: 15px;
        font-weight: 600;
    }
}
.wrap{
    padding: 15px;
    .join-image{
        margin:0 auto;
        width: 193px;
    }
    .form{
        padding: 26px 30px;
        background: url("~@/assets/vipCoach/v2/bg_sr.png");
        background-size: 100% 100%;
        &-item{
            display: flex;
            align-items: center;
            padding-bottom: 12px;
            margin-top: 24px;
            border-bottom: 1px solid #ccc;
            &:first-child{
                margin-top: 0;
            }
            &__icon{
                margin-right: 10px;
                width: 24px;
                height: 24px;
            }
            &__input{
                flex: 1;
                width: 0;
                border: 0;
                font-size: 14px;
            }
            &__code{
                flex: 0 0 60px;
                border:1px solid #eee;
                border-radius: 2px;
                overflow: hidden;
            }
            &__reset{
                margin-left: 7px;
                width: 18px;
                height: 18px;
            }
            &__btn{
                flex: 0 0 100px;
                height: 30px;
                line-height: 30px;
                color: #53CB85;
                font-size: 13px;
                border-radius: 5px;
                text-align: center;
                border: 1px solid #53CB85;
                &.disabled{
                    color:#aaa;
                    border-color: #aaa;
                }
            }
        }
    }
    .agreement{
        margin-top: 15px;
        font-size: 13px;
        a{
            color:#53CB85;
        }
    }
}
.custom-btn{
    margin-top: 10px;
    width: 345px;
    height: 45px;
    line-height: 45px;
    color: #FFFFFF;
    font-size: 18px;
    font-weight: 600;
    background: url("~@/assets/vipCoach/v2/icon_ljjr.png");
    background-size: 100% 100%;
    text-align: center;
}
</style>
